
import { loteItemStore, ordemCarregamentoStore } from '@/store';
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import VueQrcodeReader from 'vue-qrcode-reader';

@Component({
  components: {
    VueQrcodeReader,
  },
})
export default class ScanQRCodeComponent extends Vue {
  @Prop({ type: String, default: 'Abrir' }) readonly buttonLabel!: string;
  @Prop({ type: Object, default: () => {} }) readonly kwargs!: any;
  @Watch('isOpen')
  onClose(isOpen) {
    if (isOpen) {
      this.camera = 'auto';
    } else {
      this.camera = 'off';
    }
  }

  @Prop({ default: '' }) readonly propTitle;

  // options: "qrInfo", "parsedString", "decodedString"
  @Prop({ default: 'qrInfo' }) readonly returnType;

  // Fechar dialog após decode
  @Prop({ default: false }) readonly closeAfterDecode;

  // Se permite digitar UUID
  @Prop({ default: false }) readonly allowTypedUUID;

  // Comparar item escaneado com um item_id
  @Prop({ default: null }) readonly checkWith;

  @Prop({ default: null }) readonly description;
  @Prop({ default: 'book' }) readonly type;

  public isOpen = false;
  public error = '';
  public camera = 'auto';
  public typedUUID = '';

  @Emit('decode')
  public async onDecode(decodedString) {
    let returnValue: any = undefined;
    this.camera = 'off';

    if (!decodedString) {
      return;
    }

    switch (this.type) {
      case 'book':
        const parsedString = decodedString.split('=')[1].toUpperCase();
        switch (this.returnType) {
          case 'parsedString':
            returnValue = parsedString;
            break;
          case 'qrInfo':
            returnValue = await this.getBookInfo(parsedString);
            break;
          default:
            returnValue = decodedString;
            break;
        }
        break;
      case 'oc':
        returnValue = await this.getOcInfo(decodedString);
    }

    if (this.closeAfterDecode) {
      this.isOpen = false;
      this.camera = 'off';
    } else {
      setTimeout(() => {
        this.camera = 'auto';
      }, 500);
    }

    return returnValue;
  }

  public async getBookInfo(parsedString: string) {
    this.typedUUID = '';
    let productInfo: any = undefined;
    const returnObj: any = {
      isBackoffice: !parsedString.includes('-'),
      productInfo: undefined,
    };

    if (returnObj.isBackoffice) {
      productInfo = await loteItemStore.getLoteItemByRegistroFabricante(parsedString);
    } else {
      productInfo = await loteItemStore.getLoteItemByUUID(parsedString);
    }

    if (!productInfo || productInfo.length === 0) {
      this.$swal({
        title: 'Produto não encontrado',
        icon: 'error',
        html: `Nenhum produto encontrado com o código <b>${parsedString}</b>`,
      });
    }

    if (this.checkWith && productInfo) {
      if (returnObj.isBackoffice) {
        const correctProduct = _.find(productInfo, {
          item_id: this.checkWith,
        });
        if (correctProduct) {
          productInfo = correctProduct;
        } else {
          this.$swal({
            title: 'Produto incorreto',
            icon: 'error',
            html: `Você escaneou o produto <b>${productInfo[0].item_name}</b>`,
          });
          return;
        }
      } else {
        if (this.checkWith != productInfo.item_id) {
          this.$swal({
            title: 'Produto incorreto',
            icon: 'error',
            html: `Você escaneou o produto <b>${productInfo.item_name}</b>`,
          });
          return;
        }
      }
    }

    returnObj.productInfo = productInfo;

    return returnObj;
  }

  async getOcInfo(encryptedString: string) {
    return await ordemCarregamentoStore.getOrdemCarregamentoByQRCode({
      encryptedString: encryptedString,
      ...this.kwargs,
    });
  }

  public async onInit(promise) {
    try {
      await promise;
    } catch (error) {
      if (error instanceof Error)
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permission';
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser';
        } else if (error.name === 'InsecureContextError') {
          this.error =
            'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.error = `ERROR: Camera error (${error.name})`;
        }
    } finally {
      // hide loading indicator
    }
  }
}
